import { theme } from '@orobix/orobix-fe-components'
import { createUseStyles } from 'react-jss'

export const useStyles = createUseStyles((t: typeof theme) => ({
  footerButtonWrapper: {
    textWrap: 'auto',
    display: 'flex',
    gap: '1rem',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  descriptionText: {
    whiteSpace: 'break-spaces',
  },
  inputContainer: {
    marginTop: '1rem',
    textWrap: 'auto',
    wordWrap: 'break-word',
    overflowWrap: 'break-word',
    '& label': {
      textWrap: 'auto',
      wordWrap: 'break-word',
      overflowWrap: 'break-word',
      whiteSpace: 'normal',
    },
  },
  labelText: {
    fontWeight: 'bold',
    marginBottom: '0.5rem',
    fontSize: 'smaller',
  },
  helpText: {
    whiteSpace: 'normal',
    color: 'grey',
    fontSize: 'smaller',
    fontStyle: 'italic',
    marginBottom: '0.5rem',
  },
  errorText: {
    color: 'red',
    marginTop: '-1rem',
  },
  dateRangeError: {
    color: 'red',
    marginTop: '-1rem',
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    maxWidth: '100%',
  },
  rotationThresholdError: {
    color: 'red',
  },
  qmaxMinError: {
    color: 'red',
  },
  noDataText: {
    whiteSpace: 'normal',
  },
  causedByText: {
    fontWeight: 'bold',
    marginTop: '1rem',
  },
  errorLogsContainer: {
    background: '#f5f5f5',
    border: '1px solid #ddd',
    borderRadius: '4px',
    padding: '1rem',
    marginTop: '1rem',
    fontFamily: 'monospace',
    fontSize: '0.95em',
    overflowX: 'auto',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  },
  errorLogsPre: {
    background: 'none',
    border: 'none',
    margin: 0,
    padding: 0,
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  },
  separator: {
    borderTop: '1px solid #ddd',
    marginTop: '1.5rem',
    marginBottom: '1rem',
    width: '30%',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  scrollableContent: {
    maxHeight: '500px',
    overflowY: 'auto',
    paddingRight: '0.5rem',
  },
  advancedSettings: {
    marginTop: '1rem',
    '& summary': {
      cursor: 'pointer',
      fontWeight: 'bold',
      fontSize: 'smaller',
      color: t.primary,
      '&:hover': {
        textDecoration: 'underline',
      },
    },
  },
  advancedSettingsContent: {
    paddingTop: '0.5rem',
  },
  pipelineGroup: {
    marginBottom: '1rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
  },
  pipelineOption: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    cursor: 'pointer',
    fontSize: 'smaller',
  },
  pipelineDescription: {
    whiteSpace: 'normal',
    color: 'grey',
    fontSize: 'smaller',
    fontStyle: 'italic',
    marginTop: '0.5rem',
  },
}))
